import Layout from 'HorizontalMenu/Menu'
import Navbar from 'HorizontalMenu/Navbar'
import React, { useEffect, useState } from 'react'
import {
    Container,
    CardBody,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Row,
    Col,
    Label
} from 'reactstrap'
import classnames from 'classnames'
import Select from 'react-select'
import { getVesselsAction, setOnboardedVessels, setVesselID } from 'Store/Generic/ReportingSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'index'
import { OnboardingStatus } from 'shared/constants'
import { customStyle } from 'shared/CommonCSS'
import LubeOilROBData from './LubeOilROBData'
import FWROBData from './FWROBData'
import FOROBData from './FOROBData'
import { getDefaultVesselValue } from 'GenericForms/Helper'
import { userVessels } from 'utils/auth/authUtils'
import Message from 'Components/Message'

const ROBTabs = {
    FUEL_OIL: "1",
    LUBE_OIL: "2",
    FRESH_WATER: "3",
};

const ROBData = () => {
    const dispatch = useDispatch();
    let applicableVessels = userVessels();
    const { Vessels, VesselID, onboardedVessels } = useSelector(
        (state: RootState) => state.Reporting
    );
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);

    const [activeROBTab, setActiveROBTab] = useState(ROBTabs.FUEL_OIL);

    const toggle = (tab: string) => {
        if (activeROBTab !== tab) {
            setActiveROBTab(tab);
        }
    };
    /** set global vessel */
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e ? e?.id : null));
    };
    /** useEffect */
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);

    /** Effect 2: Set onboarded vessels when Vessels data is available */
    useEffect(() => {
        if (Array.isArray(Vessels)) {
            const onboardedVessels = Vessels.filter(
                (vessel) => vessel.onboarding_status === OnboardingStatus.ONBOARDED
            );
            dispatch(setOnboardedVessels(onboardedVessels));
        }
    }, [Vessels, dispatch]);
    /** useEffect end */
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>

            <div className="page-content">
                <Container fluid>
                    <Row className="mb-2">
                        <Col sm={4}>
                            <Label className="mb-0">Select vessel</Label>
                            <Select
                                options={
                                    onboardedVessels.filter((item: any) => item.display === true &&
                                        applicableVessels?.includes(item?.id)) as any[]
                                }
                                getOptionLabel={(o: any) =>
                                    `${o.vessel_name_type_name}`
                                }
                                isClearable={true}
                                getOptionValue={(option: any) => option.id}
                                onChange={(e: any) => handleVesselSelectionChanges(e)}
                                menuPortalTarget={document.body}
                                styles={customStyle}
                                defaultValue={getDefaultVesselValue(
                                    VesselID,
                                    vessel,
                                    onboardedVessels,
                                    applicableVessels
                                )}
                            />
                            {VesselID === null && (<div className='mt-2'><Message type="warning" message="Please select a vessel to view ROB Data." /></div>)}
                        </Col>

                        <Col sm={8} className="pt-3 text-end">
                            <div className="d-inline-block">
                                <h3 className="m-0">ROB Data</h3>
                            </div>
                        </Col>
                    </Row>

                    {/* ---------------- SHOW TABS ONLY WHEN VESSEL SELECTED ---------------- */}
                    {VesselID && (
                        <>
                            {/* HEADER TABS */}
                            <CardBody className="pb-0 pt-0">
                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    {/* FUEL OIL */}
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active:
                                                    activeROBTab === ROBTabs.FUEL_OIL,
                                            })}
                                            onClick={() => toggle(ROBTabs.FUEL_OIL)}
                                        >
                                            Fuel Oil
                                        </NavLink>
                                    </NavItem>

                                    {/* LUBE OIL */}
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active:
                                                    activeROBTab === ROBTabs.LUBE_OIL,
                                            })}
                                            onClick={() => toggle(ROBTabs.LUBE_OIL)}
                                        >
                                            Lube Oil
                                        </NavLink>
                                    </NavItem>

                                    {/* FRESH WATER */}
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active:
                                                    activeROBTab ===
                                                    ROBTabs.FRESH_WATER,
                                            })}
                                            onClick={() => toggle(ROBTabs.FRESH_WATER)}
                                        >
                                            Fresh Water
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CardBody>

                            {/* TAB CONTENT */}
                            <TabContent
                                activeTab={activeROBTab}
                                className="p-3 text-muted"
                            >
                                <TabPane tabId={ROBTabs.FUEL_OIL}>
                                    <FOROBData activeTab={activeROBTab} />
                                </TabPane>

                                <TabPane tabId={ROBTabs.LUBE_OIL}>
                                    <LubeOilROBData activeTab={activeROBTab} />
                                </TabPane>

                                <TabPane tabId={ROBTabs.FRESH_WATER}>
                                    <FWROBData activeTab={activeROBTab} />
                                </TabPane>
                            </TabContent>
                        </>
                    )}
                </Container>
            </div>
        </React.Fragment>

    )
}

export default ROBData;

